<template>
    <Paper :header="header" tall>
        <div style="overflow: hidden;" class="rounded-bottom">
            <LinkCarouselItem :title="title" :img="img" :link="link" :inSameWindow="inSameWindow" />
        </div>
    </Paper>
</template>

<script>
import LinkCarouselItem from '~/components/miscellaneous/Link.CarouselItem';

export default {
    name: 'Resource',
    components: { LinkCarouselItem },
    props: {
        header: {
            type: String,
            default: () => '',
        },
        title: {
            type: String,
            default: () => '',
        },
        img: {
            type: String,
            default: () => '',
        },
        link: {
            type: String,
            default: () => '',
        },
        inSameWindow: {
            type: Boolean,
            default: () => false,
        },
    },
};
</script>
